<template>
  <div class="content-header">
    <div class="banner_bidding" style="margin-top:-10px;">        
        <img :src="banner_src" @click="banner_move()" style="width: 1110px; height: 100px; cursor:pointer;">
      </div>
      <div class="relative" style="margin-top: 20px;">
      <h2  class="subTitle">파트너스</h2>
    </div>
  </div>  
</template>

<script>
export default {
  data(){
    return{
      banner_src : "/static/images/test_banner.png",
      banner_is_external : false,
      banner_taget_url : "/",
      banner_id : 0
    }
  },
  methods:{
    banner_move(){
      this.$http.post("app/click_banner", this.qs({ id:this.banner_id })).then(res=>{
        if(this.banner_is_external == false){
          this.$router.push(this.banner_taget_url)
        }else{
          window.open(this.banner_taget_url)
        }
      })      
    },
    get_banner(){
      this.$http.get(`app/get_banner?position=partners`).then(res=>{
        if(JSON.stringify(res.data.result) != JSON.stringify({})){
          this.banner_src = this.src + res.data.result.image
          this.banner_taget_url = res.data.result.target_link
          this.banner_is_external = res.data.result.is_external
          this.banner_id = res.data.result.id
        }else{
          // 파트너스 디폴트 배너 
        }      
      })
    }
  },
  mounted(){
    this.get_banner();
    
  }
};
</script>

<style lang="scss" scoped>
.content-header {  
  margin: 0;
  margin-bottom: 5px;
  background-color: #fff;  
  border-radius: 3px;
  border-bottom-width: 2px;
  padding: 30px 0px;
  padding-bottom: 0px;
  display: table;
  width: 1060px;
  h3 {
    width: 600px;
    float: left;
    margin-bottom: 0px;
    .small-text {
      line-height: 20px;
      margin-top: 10px;
      display: block;
      color: #999;
      font-size: 17px;
    }
  }
  .search {
    width: 398px;
    float: left;
    margin-top: 30px;
    text-align: right;
    form {
      display: block !important;
    }
    .form-group {
      margin-left: 5px;
      vertical-align: middle;
      display: inline-block;
      text-align: right;
      .form-control {
        font-size: 12px;
        height: 26px;
        padding: 4px 10px;
        line-height: 18px;
        display: inline-block;
        width: auto;
        vertical-align: middle;
        color: #666;
        background-color: #fff;
        background-image: none;
        border: 1px solid #dedede;
        border-radius: 2px;
      }
      .form-control:focus {
        outline: none !important;
        box-shadow: none !important;
      }
      .btn-wishket {
        color: #fff;
        background-color: #2099bb;
        border-color: #1c87a5;
      }
    }
  }
   h2.subTitle {
    position: relative;
    color: #373737;
    font-size: 34px;   
    margin-bottom: 0px;
    line-height: 1;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 20px;
}
}
</style>



// WEBPACK FOOTER //
// src/SPA/CompanyList/Components/CompanyListHeader.vue